import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import AccountDetailsContent from "./AccountDetailsContent";

function AccountDetailsMain() {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Humanize Texts user account</title>
      <meta name="robots" content="noindex"></meta>
      <meta
        name="description"
        content="Humanize ai written texts, detect ai written texts, paraphrase texts."
      ></meta>
      <meta
        name="keywords"
        content="sumarizer,paraphrasing tool,paraphrase,artificial intelligence detector,aı detector,paraphraser,humanizer,ai humanizer,ai to human text,ai checker"
      ></meta>
      {/* NavBar component */}
      <NavBar />
      {/* Account Details Content */}
      <AccountDetailsContent />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default AccountDetailsMain;
